import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux'
import { addUserHome, setOrgId, getOrgId, getTypeButton, setTypeButton, setUserHomeDetails, setOrgData, setLoading } from '../reducer/dashboardSlice';
import { useEffect } from 'react';

export default function MenuTabMobile(props) {
  const {handleHome, _handleIconCLick, menuTitle,selectedTab,setSelectedTab} = props;
  const typeButton = useSelector(getTypeButton);
  const [value, setValue] = React.useState(selectedTab ? selectedTab : typeButton);
  const orgId = useSelector(getOrgId);
  const dispatch = useDispatch();
  useEffect(() => {
    setValue(selectedTab ? selectedTab : typeButton)
  }, [selectedTab, typeButton])

  const handleChange = (newValue) => {
    setSelectedTab(newValue);
    setValue(newValue);
    let value = 0;
    if(newValue === 'Tests' || newValue === 'Feedback' || newValue === 'Survey'){
        value = 0;
    }else if(newValue === 'Completed' || newValue === 'FeedbackCompleted' || newValue === 'CompletedSurvey'){
        value = 1;
    }else{
        // eslint-disable-next-line unused-imports/no-unused-vars
        value = 2;
    }
    let data = {
        newValue: newValue,
        org : orgId,

    }

    dispatch(setLoading(true));
    dispatch(addUserHome(data)).then((response)=>{
        dispatch(setUserHomeDetails(response.payload))
        dispatch(setTypeButton(newValue))
        // dispatch(setGroupDetails(response.payload.groups))
        dispatch(setOrgId(response.payload.latestOrg))
        dispatch(setOrgData(response.payload.org))
        let typeData = response.payload;
        handleHome(typeData,newValue)
        dispatch(setLoading(false))
      }).catch((e)=>{
          console.log(e)
          dispatch(setLoading(false))
      })
  };

  return (
    <div>
        <FormControl variant="standard" style={{ width: "auto" }} >
        <InputLabel id="test-dropdown-input-label">Tests</InputLabel>
        <Select
          labelId="test-dropdown-label"
          id="test-dropdown"
          value={value}
          onChange={(e)=>handleChange(e.target.value)}
          label="Tests"
          style = {{textTransform: 'uppercase',color: '#6f2981', fontSize:'14px'}}
        >
          <MenuItem value={menuTitle[0]}>{
            menuTitle[0] === 'Tests' ? "Pending Test" :
            menuTitle[0] === 'Survey' ? "Pending Survey" :
            menuTitle[0] === 'WorkFlow' ? 'Pending WorkFlow' :
            menuTitle[0] === 'Disabled Groups' ? 'Disabled Tests' :
            "Pending Feedback"
          }</MenuItem>
          <MenuItem value={menuTitle[1]}>{
            menuTitle[1] === 'Completed' ? "Completed Test" :
            menuTitle[1] === 'SurveyCompleted' ? "Completed Survey" :
            menuTitle[1] === 'WorkFlowCompleted' ? 'Completed WorkFlow' :
            menuTitle[1] === 'Disabled Feedback' ? 'Disabled Feedback' :
            "Completed Feedback"
          }</MenuItem>
          <MenuItem value={menuTitle[2]}>{
            menuTitle[2] === 'Expired' ? "Expired Test" :
            menuTitle[2] === 'SurveyExpired' ? "Expired Survey" :
            menuTitle[2] === 'WorkFlowExpired' ? 'Expired WorkFlow' :
            menuTitle[2] === 'Disabled Survey' ? 'Disabled Survey' :
            "Expired Feedback"
          }</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}